import { Outlet } from "react-router-dom";

const ProgramRequestLayout = () => {
  return <Outlet />;
};

export default ProgramRequestLayout;